export var FeatureName = {
  rowDrag: 'rowDrag'
};